import { createContext } from 'react';

export interface ErrorContextValue {
  pushError: (message: string) => void;
}

export const ErrorContext = createContext<ErrorContextValue | null>(null);
